import { Flex, Icon, Text } from '@chakra-ui/react';
import { TransactionStageType } from '@client/graphql/__generated__/types';
import { PlusCircle } from 'lucide-react';
import { useNavigate, useParams } from 'react-router';

interface AddNotificationButtonProps {
  eventType: TransactionStageType;
}

export const AddNotificationButton = ({
  eventType,
}: AddNotificationButtonProps) => {
  const navigate = useNavigate();
  const { partnerId } = useParams<{ partnerId: string }>();

  const handleClick = () => {
    if (partnerId) {
      navigate(
        `/organizations/notifications/partners/${partnerId}/new?eventType=${eventType}`
      );
    }
  };

  if (!partnerId) {
    return null;
  }

  return (
    <Flex
      _hover={{ borderColor: 'whiteAlpha.500' }}
      alignItems="center"
      border="1px dashed"
      borderColor="whiteAlpha.300"
      borderRadius="lg"
      cursor="pointer"
      gap={2}
      height="180px"
      justifyContent="center"
      transition="border-color 0.2s"
      onClick={handleClick}
    >
      <Icon as={PlusCircle} boxSize={5} color="whiteAlpha.400" />
      <Text color="whiteAlpha.400">Add notification</Text>
    </Flex>
  );
};
